<template>
  <div v-if="privacyData.header" class="page page-home">
    <div id="scrollItem"
             :class="['pageContent', themeText()]">
            <div class="header">
                <p class="time">{{ privacyData.header.download }}<a href="../static/mobile-service-privacy-new.pdf"
                                                                    download="移动服务个人信息保护政策.pdf"><span>{{ privacyData.header.clickDownload }}</span></a></p>
                <span class="time">{{ privacyData.header.updateTime }}</span>
                <span class="time">{{ privacyData.header.effectTime }}</span>
            </div>
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph1.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph1.content">
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph2.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph2.content">
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph3.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph3.content">
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph4.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph4.content">
                </div>
                <div v-for="(item,index) in privacyData.paragraph4.list"
                     :key="index"
                >
                    <div class="title">{{ item.title }}</div>
                    <div class="contentWrap"
                         v-html="item.content">
                    </div>
                    <div v-for="(secItem,secIndex) in item.secondWrap"
                         :key="secIndex">
                        <div class="title">{{ secItem.title }}</div>
                        <div class="contentWrap"
                             v-html="secItem.content">
                        </div>
                        <div v-for="(thiItem,thiIndex) in secItem.thirdWrap"
                             :key="thiIndex">
                            <div class="title">{{ thiItem.title }}</div>
                            <div class="contentWrap"
                                 v-html="thiItem.content">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph5.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph5.content">
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph6.title }}</div>
                <div v-for="(item,index) in privacyData.paragraph6.list"
                     :key="index"
                >
                    <div class="title">{{ item.title }}</div>
                    <div class="contentWrap"
                         v-html="item.content">
                    </div>
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph7.title }}</div>
                <div v-for="(item,index) in privacyData.paragraph7.list"
                     :key="index"
                >
                    <div class="title">{{ item.title }}</div>
                    <div class="contentWrap"
                         v-html="item.content">
                    </div>
                    <div v-for="(secItem,secIndex) in item.secondWrap"
                         :key="secIndex">
                        <div class="title">{{ secItem.title }}</div>
                        <div class="contentWrap"
                             v-html="secItem.content">
                        </div>
                    </div>
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph8.title }}</div>
                <div v-for="(item,index) in privacyData.paragraph8.list"
                     :key="index"
                >
                    <div class="title">{{ item.title }}</div>
                    <div class="contentWrap"
                         v-html="item.content">
                    </div>
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph9.title }}</div>
                <div v-for="(item,index) in privacyData.paragraph9.list"
                     :key="index"
                >
                    <div class="title">{{ item.title }}</div>
                    <div class="contentWrap"
                         v-html="item.content">
                    </div>
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph10.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph10.content">
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph11.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph11.content">
                </div>

            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph12.title }}</div>
                <div v-for="(item,index) in privacyData.paragraph12.list"
                     :key="index"
                >
                    <div class="title">{{ item.title }}</div>
                    <div class="contentWrap"
                         v-html="item.content">
                    </div>
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph13.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph13.content">
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph14.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph14.content">
                </div>
            </div>
            <paragraphDivisionLine />
            <div class="paragraph">
                <div class="title">{{ privacyData.paragraph15.title }}</div>
                <div class="contentWrap"
                     v-html="privacyData.paragraph15.content">
                </div>
            </div>
    </div>
  </div>
</template>

<script>
import paragraphDivisionLine from '@/components/paragraphDivisionLine/index.vue';
import { getTheme } from '@/utils/index';
import setStateBarColor from '@/utils/setStateBarColor';
export default {
  components: {
    paragraphDivisionLine,
   },
 data() {
  return {
    privacyData:{}
  };
 },
 methods: {
  getThemeFn(){
    getTheme()
  },
  setStateBarColor(){
    if(this.getThemeFn()) {
           setStateBarColor(1, 'FAFAFA');
     }else {
         setStateBarColor(1, '050505');
     }
  },
   handleDetailedList() {
      this.$router.push({
          name: 'detailedList',
          query: { Jump: 'true' },
      });
    },
    handleApplicationPermission() {
      this.$router.push({
          name: 'applicationPermission',
          query: { Jump: 'true' },
      });
    },
    handleShareList() {
      this.$router.push({
          name: 'shareList',
          query: { Jump: 'true' },
      });
    },
    themeText(){
      if(this.getThemeFn()) {
          return 'dark';
      }else {
          return 'light';
      }
    }
 },
 mounted(){
   this.setStateBarColor();
    this.privacyData = require(`@/utils/tpls.json`).homePage;
 }
};
</script>

<style lang="stylus" scoped>
@import '@/style/var.styl';
.page {
    * {
        box-sizing: border-box;
    }
}

.page-home {
    font-size: 0.16rem;
    overflow: scroll;

    .pageContent {
        overflow: scroll;
        position: relative;
        padding:0rem 0.16rem 0 0.16rem;
        .header{
          margin-bottom: 0.32rem;
        }
        .paragraph {
            margin-bottom: 0.32rem;
        }
        /deep/.contentWrap{
            p{
                font-size:0.14rem;
                line-height: 0.21rem;
                margin-bottom: 0.32rem
                word-break: break-all;
            }
        }

        .time {
           margin-top:0.08rem;
           font-size:0.14rem;
           color: rgba(0, 0, 0, 0.55);
           display:block;
        }
        .title{
            font-weight: 500;
            line-height: 23px;
            font-size: 0.18rem;
            margin-bottom: 0.08rem
        }
         .headerLine {
            margin-bottom: 0.32rem;
            width: 3.28rem;
            height: 0.01rem;
            background: #000000;
            opacity: 0.12;
       }
    }
    .tableWrap {
        width: auto;
        overflow: auto;
        display: flex;
        flex-direction: row;

        * {
            box-sizing: border-box;
        }

        .spaceWrap {
            border-left: .16rem solid transparent;
        }
    }
    .table {
        overflow-x: scroll;
        position: relative;
        border-collapse: collapse;
        border-spacing: 0;

        .titleWrap {
            font-size: 0.12rem;
            line-height: 0.16rem;
            display: flex;
            flex-direction: row;
            overflow: hidden;

            th {
                height: 0.4rem;
                width: 1.16rem;
                display: flex;
                flex: 1;
                padding: 0.12rem 0.16rem;
                align-items: center;
                text-align: left;
                // border-top: 0;
                border-right: 0;
                border-bottom: 0;
            }
        }

        .dataLine {
            font-size: 0.12rem;
            display: flex;
            flex-direction: row;

            td {
                width: 1.16rem;
                display: flex;
                flex: 1;
                padding: 0.16rem;
                line-height: 0.16rem;
                align-items: center;
                text-align: center;
                z-index: 1;
                word-wrap: break-word;
                word-break: break-all;
                text-align: left;
                border-bottom: 0;
                border-right: 0;
            }
        }

        .tableLine {
            position: absolute;
            height: 100%;
            top: 0;
        }
    }
    .dark {
        background: #050505;
        .time {
            color: rgba(255, 255, 255, 0.55);
        }
        .title{
                color: rgba(255, 255, 255, 0.85);
        }
        /deep/.contentWrap{
            p{
               color: rgba(255, 255, 255, 0.55);
            }
        }
        /deep/.contentWrapList{
            p{
               color: rgba(255, 255, 255, 0.55);
            }
        }
        .content{
            color: rgba(255, 255, 255, 0.55);
        }
        .titleWrap {
            color: rgba(255, 255, 255, 0.85);
        }
        th {
             background: rgba(255, 255, 255,0.06);
            border: 0.0033rem solid rgba(255, 255, 255, 0.1);
        }
        td {
           background: #000000;
           border: 0.0033rem solid rgba(255, 255, 255, 0.1);
        }
        .dataLine{
            color: rgba(0, 0, 0, 0.55);
        }
        .columns {
            color: rgba(255, 255, 255, 0.55);
        }
        table tr td:last-child {
          border-right: 0.0033rem solid rgba(255, 255, 255,0.1) !important;
        }
        table tr:first-child th:last-child {
          border-right: 0.0033rem solid rgba(255, 255, 255,0.1) !important;
        }
        table tr:last-child td {
            border-bottom: 0.0033rem solid rgba(255, 255, 255,0.1) !important;
        }
     }

    .light {
        background: #FAFAFA;
        .time {
           color: rgba(0, 0, 0, 0.55);
        }
        .title{
             color: rgba(0, 0, 0, 0.85)
        }
        /deep/.contentWrap{
            p{
               color: rgba(0, 0, 0, 0.55);
            }
        }
        .content{
            color: rgba(0, 0, 0, 0.55);
        }
        .titleWrap {
            color: rgba(0, 0, 0, 0.85);
        }
        th {
            background: rgba(0, 0, 0, 0.06);
            border: 0.0033rem solid rgba(0, 0, 0, 0.1);
        }
       td {
           background: #ffffff;
           border: 0.0033rem solid rgba(0, 0, 0, 0.1);
        }
       .dataLine{
            color: rgba(255, 255, 255, 0.55);
        }
        .columns {
            color: rgba(0, 0, 0, 0.55);
        }
        table tr td:last-child {
          border-right: 0.0033rem solid rgba(0,0,0,0.1) !important;
        }
        table tr:first-child th:last-child {
          border-right: 0.0033rem solid rgba(0,0,0,0.1) !important;
        }
        table tr:last-child td {
            border-bottom: 0.0033rem solid rgba(0,0,0,0.1) !important;
        }
    }
}
</style>
